import Board from "../models/board";
import { apiResultSuccess, getTasks, getTasksTargetDate } from "../apihelper";
import { Task } from "../models/task";
import { GeneralObserver } from "../components/Observer";
import { ControllerSubject } from "../components/Subject";
import { dateIsToday, getDateProp, isAFunction, timeTravel } from "../global/utils";
import { EVENTS } from "../global/constants";

export default class TasksController extends Board {
    constructor(
        id=-1, 
        title='', 
        type='', 
        orderIndex=-1,
        dateCreated='', 
        lastUpdated='', 
        hidden=false
    ) {
        super(id, title, type, orderIndex, dateCreated, lastUpdated, hidden);

        this.tasks = [];
        this.currentDate = new Date();
        this.reactFn = this.reactFn.bind(this);
        
        this.observer = new GeneralObserver(this.reactFn);
    }

    getTasks() {
        return this.tasks;
    }

    setTasks(tasks=[]) {
        this.tasks = tasks;
    }

    setCurrentDate(newDate=new Date()) {
        this.currentDate = newDate;
    }

    getCurrentDate() {
        return this.currentDate;
    }

    getObserver() {
        return this.observer;
    }

    // Checks if currentDate is today
    currentDateIsToday() {
        return dateIsToday(this.currentDate);
    }

    // Fetch tasks data
    async fetchTasks() {
        return await this.fetchCurrentDateTasks();
    }

    // Reloads data by calling fetch fn 
    async reloadData() {
        return await this.fetchTasks();
    }
    
    // API results helper
    // Checks for success result
    // Upon sucess call createTasks with the result
    // Runs reload on subject
    handleAPIResult(results) {
        if ( apiResultSuccess(results) ) {
            if ( results.tasks ) {
                this.createTasks(results.tasks);

                if ( this.subject ) {
                    this.subject.runReload();
                }
            }
        }
    }

    // Iterate through newTasks: list of tasks 
    // For each item, create a Task object
    // add append it to a tasks array
    // Update tasks property with the new array
    createTasks(newTasks=[]) {
        const tasks = [];
        
        newTasks.forEach(taskData => {
            const newTask = new Task(taskData);
            tasks.push(newTask);
        });

        this.setTasks(tasks);
    }
   
    // Observer calls this fn when it reacts to an event
    // It reloads data
    // The observer is connected to ToDoController
    // ToDoController events trigger reload data
    reactFn(event) {
        if ( event.name === EVENTS.update ) {
            this.reloadData();
        }       
    }
    
    // Converts currentDate into a date string
    // Then tasks for currentDate
    async fetchCurrentDateTasks() {
        const targetDateStr = getDateProp(this.currentDate, 'date');
        const postData = { target_date: targetDateStr };

        return await getTasksTargetDate(
            (results) => {
                this.handleAPIResult(results);
            },
            postData
        )
    }

    // Sets currentDate to targetDate
    // then fetches tasks for that day
    goToDate(targetDate=new Date()) {
        // set currentDate
        this.setCurrentDate(targetDate);
        this.fetchCurrentDateTasks();
    }

    // Retreats currentDate by one
    // Then fetches tasks for that day
    goToPrevDate() {
        const targetDate = timeTravel(this.currentDate, "prev");
        this.goToDate(targetDate);
    }

    // Goes to today
    // Then fetches tasks for today
    goToToday() {
        this.goToDate();
    }

    // Advances currentDate by one
    // Then fetches tasks for that day
    goToNextDate() {
        const targetDate = timeTravel(this.currentDate, "next");
        this.goToDate(targetDate);
    }
}